<template>
  <form  data-vv-scope="otpForm">
    <div class="form-group" id="opt-form">
      <input
        name="num1"
        v-model="otp.num1"
        v-validate="'required|numeric|max:1'"
        maxlength="1"
        :class="{ 'form-control otp-form__item': true, 'input': true, 'is-danger': errors.has('otpForm.num1') }"
        type="text"
        autofocus
      />

      <input
        name="num2"
        v-model="otp.num2"
        v-validate="'required|numeric|max:1'"
        maxlength="1"
        :class="{ 'form-control otp-form__item': true, 'input': true, 'is-danger': errors.has('otpForm.num2') }"
        type="text"
      />

      <input
        name="num3"
        v-model="otp.num3"
        v-validate="'required|numeric|max:1'"
        maxlength="1"
        :class="{ 'form-control otp-form__item': true, 'input': true, 'is-danger': errors.has('otpForm.num3') }"
        type="text"
      />

      <input
        name="num4"
        v-model="otp.num4"
        v-validate="'required|numeric|max:1'"
        maxlength="1"
        :class="{ 'form-control otp-form__item': true, 'input': true, 'is-danger': errors.has('otpForm.num4') }"
        type="text"
      />

      <input
        name="num5"
        v-model="otp.num5"
        v-validate="'required|numeric|max:1'"
        maxlength="1"
        :class="{ 'form-control otp-form__item': true, 'input': true, 'is-danger': errors.has('otpForm.num5') }"
        type="text"
      />

      <input
        name="num6"
        v-model="otp.num6"
        v-validate="'required|numeric|max:1'"
        maxlength="1"
        :class="{ 'form-control otp-form__item': true, 'input': true, 'is-danger': errors.has('otpForm.num6') }"
        type="text"
      />
    </div>
  </form>
</template>

<script>
export default {
  name: 'OtpForm',

  data() {
    return {
      otp: {
        num1: '',
        num2: '',
        num3: '',
        num4: '',
        num5: '',
        num6: ''
      },
    }
  },

  props: {
    reset: {
      type: Boolean,
      require: true
    }
  },

  computed: {
    enableForm() {
      return !this.errors.items.length &&
        !!this.otp.num1 &&
        !!this.otp.num2 &&
        !!this.otp.num3 &&
        !!this.otp.num4 &&
        !!this.otp.num5 &&
        !!this.otp.num6
    },

    otpInput() {
      return `${this.otp.num1}${this.otp.num2}${this.otp.num3}${this.otp.num4}${this.otp.num5}${this.otp.num6}`
    }
  },

  mounted() {
    $(document).ready(function() {
      const CODE_LENGTH = 6

      $('#opt-form input').each(function(index, item) {
        var $this = this
        if (index === 0) $this.focus()

        $(this).keyup(function(e) {
          // check backspace
          if (e.keyCode === 8 && index > 0 && !this.value) {
            $(this).prev().focus()
          }

          if (e.keyCode !== 8) {
            if (e.keyCode < 48 || e.keyCode > 57) return // 0 - 9
            if (index === (CODE_LENGTH - 1)) return
            if (!$.isNumeric(this.value) || parseInt(this.value) > 10 || this.value.length > 2) return

            $(this).next().focus()
          }
        })
      })
    })
  },

  watch: {
    enableForm(val) {
      this.$emit('inputEnable', { enable: val, otp: this.otpInput })
    },

    reset(val) {
      if (!val) return
      this.$validator.reset()
      this.otp = {
        ...this.otp,
        ...{
          num1: '',
          num2: '',
          num3: '',
          num4: '',
          num5: '',
          num6: ''
        }
      }
    }
  }
}
</script>

<style lang="scss" scope>
  #opt-form {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #opt-form .otp-form__item {
    width: 80px;
    height: 80px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
  }

  #opt-form .otp-form__item:focus {
    border-color: #412386;
  }

  @media screen and (max-width: 700px) {
    #opt-form {
      justify-content: center;
    }

    #opt-form .otp-form__item {
      margin: 0 8px;
      width: 40px;
      height: 40px;
    }
  }

  @media screen and (max-width: 400px) {
    #opt-form .otp-form__item {
      margin: 0 4px;
      width: 32px;
      height: 32px;
      font-size: 11px;
    }
  }
</style>
